import { useTranslation } from 'react-i18next';
import useStyles from '../styles';
import React, { useState } from 'react';
import { TextField, IconButton } from '@material-ui/core';
import { ReactComponent as PostQuestion } from '../../../../icons/LogoMark.svg';

const Input = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [inputValue, setInputValue] = useState('');

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      console.log('Enter pressed! Current Input:', inputValue);
    }
  };

  return (
    <div className={classes.inputContainer}>
      <TextField
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        fullWidth
        variant="outlined"
        placeholder={t('askBot.searchBar')}
        className={classes.textField}
        InputProps={{
          endAdornment: (
            <IconButton style={{ padding: '0px' }}>
              <PostQuestion />
            </IconButton>
          )
        }}
      />
    </div>
  );
};

export default Input;
